import { useIcon } from './useIcon'

export async function useLoadIcon(iconName?: string) {
  if (!iconName) return undefined

  const { iconComponent, fetchIconComponent } = useIcon(() => iconName)

  await fetchIconComponent()

  return iconComponent
}
